<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="1400px">
    <v-card flat tile class="mx-auto py-3 d-flex align-center" style="height: 60vh; position: relative;">
      <v-btn
        icon
        class="close-button"
        @click="$emit('input', false)"
        style="position: absolute; top: 8px; right: 8px; z-index: 1;"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-row class="align-center" style="height: inherit;">
        <v-col cols="12" md="5" class="d-flex align-center">
          <v-card-text>
            <v-card-title>What is the Transparency Score?</v-card-title>
            <v-card-text>The Transparency Score is calculated based on global best practice public sector
              procurement
              integrity and transparency factors. In Australia, procurement transparency standards and obligations
              vary
              between jurisdictions. Where possible, these rules have been incorporated into the calculations. Visit
              the
              <a target="_blank"
                href="https://docs.tendertrace.com/guide/user-documentation/transparency-integrity-and-risk">user
                guide</a> for more information.
            </v-card-text>
          </v-card-text>
        </v-col>
        <v-col cols="12" md="7">
          <v-card flat tile width="100%">
            <transparency-spider v-if="transparencyChecks"
              :data="{ 'payload': { checks: transparencyChecks }, 'name': 'Transparency Scoring Breakdown' }" />
            <v-card-text v-else class="text-center">
              <p class="body-1">No transparency data available</p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import TransparencySpider from "./TransparencySpider.vue";

export default {
  name: "TransparencyBreakdownDialog",
  components: {
    TransparencySpider
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    transparencyChecks: {
      type: Object,
      default: null
    }
  },
};
</script>

<style scoped></style>
